var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[(_vm.loading)?_c('SplashScreen'):_c('router-view')],1),_c('AlertBar',{ref:"alertBar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }